export { default } from "./DisclosureTriangle";
